/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * NARCISA: quick add silencioso en mobile + arreglo del boton "pensando"
   *
   * 1. En mobile (menos de 750px), el boton de agregar de las tarjetas de
   *    producto (y el popup de variantes del quick add) agrega al carrito
   *    sin abrir nada: solo sube el numerito del carrito en el header.
   *    En desktop y en la pagina de producto todo sigue igual que antes.
   * 2. Cuando el navegador restaura una pagina al darle "atras", los botones
   *    vuelven a su estado normal y el numerito del carrito se actualiza.
   */

  var theme = window.theme || {};
  var MOBILE_MAX = ((theme.sizes && theme.sizes.small) || 750) - 1;
  var mobileQuery = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SKIP_ATTR = 'data-narcisa-theme-add';
  var ADDED_DELAY = 1500;

  function isQuickAddButton(button) {
    return !!(button && button.closest && button.closest('quick-add-product, [data-quick-add-holder], .product-quick-add'));
  }

  function updateCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cartCount: cart.item_count }
        }));
      })
      .catch(function() {});
  }

  function resetButton(button) {
    if (!button) return;
    button.classList.remove('is-loading', 'is-added');
    button.disabled = false;

    var holder = button.closest('[data-quick-add-holder]');
    if (holder) holder.classList.remove('is-visible', 'has-error');

    var quickAdd = button.closest('quick-add-product');
    if (quickAdd && typeof quickAdd.resetQuickAddButtons === 'function') {
      quickAdd.resetQuickAddButtons();
    }
  }

  // Corre antes que el tema (fase de captura en window)
  window.addEventListener('theme:cart:add', function(event) {
    var button = event.detail && event.detail.button;

    if (!button || !mobileQuery.matches || !isQuickAddButton(button)) return;

    // Reintento para que el tema muestre su propio mensaje de error
    if (button.hasAttribute(SKIP_ATTR)) {
      button.removeAttribute(SKIP_ATTR);
      return;
    }

    if (button.hasAttribute('disabled')) return;

    var form = button.form || button.closest('form');
    if (!form || !form.checkValidity() || form.querySelector('[type="file"]')) return;

    event.stopImmediatePropagation();

    var holder = button.closest('[data-quick-add-holder]');
    button.classList.add('is-loading');
    button.disabled = true;
    if (holder) holder.classList.add('is-visible');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function(response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(
        function() {
          button.classList.remove('is-loading');
          button.classList.add('is-added');

          // Cierra el popup de variantes si estaba abierto
          document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));

          updateCartCount();

          setTimeout(function() { resetButton(button); }, ADDED_DELAY);
        },
        function() {
          // No se pudo agregar (ej. sin inventario): el tema lo intenta y muestra el error
          resetButton(button);
          button.setAttribute(SKIP_ATTR, '');
          document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: button } }));
        }
      );
  }, true);

  // Al volver con "atras", el navegador muestra la pagina congelada.
  // Se limpian los botones que quedaron cargando y se actualiza el carrito.
  window.addEventListener('pageshow', function(event) {
    if (!event.persisted) return;

    var stuck = document.querySelectorAll(
      '[data-add-to-cart].is-loading, [data-add-to-cart].is-added, ' +
      '[data-quick-add-btn].is-loading, [data-quick-add-btn].is-added, ' +
      '[data-quick-add-modal-handle].is-loading, ' +
      'button[type="submit"].is-loading, button[type="submit"].is-added'
    );
    stuck.forEach(resetButton);

    document.querySelectorAll('[data-quick-add-holder].is-visible').forEach(function(holder) {
      holder.classList.remove('is-visible');
    });

    document.querySelectorAll('cart-items.is-loading').forEach(function(cart) {
      cart.classList.remove('is-loading');
    });

    var openModal = document.querySelector('dialog.product-quick-add[open]');
    if (openModal) {
      document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true }));
    }

    updateCartCount();
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
